import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect, type SyntheticEvent } from "react";

type SalesOption = {
  sales: number;
  name: string;
};

const salesOptions: SalesOption[] = [
  { sales: 0, name: "無" },
  { sales: 1, name: "有" },
  { sales: 9, name: "設定しない" },
];

type SalesSelectProps = {
  changedValue: (value: number | undefined) => void;
  inputValue: number;
};

export default function SalesSelect({
  changedValue,
  inputValue,
}: SalesSelectProps) {
  const initialValue = salesOptions.find(
    (element) => element.sales === parseInt(String(inputValue), 10)
  );
  const [value, setValue] = useState<SalesOption | undefined>(initialValue);

  useEffect(() => {
    if (inputValue !== undefined && inputValue !== null) {
      const newValue = salesOptions.find((item) => item.sales === inputValue);
      setValue(newValue);
    }
  }, [inputValue]);

  const handleChange = (
    _event: SyntheticEvent,
    newValues: SalesOption | null
  ) => {
    setValue(newValues ?? undefined);
    changedValue(newValues?.sales);
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={salesOptions}
      getOptionLabel={(option) => (option.name ? option.name : "")}
      isOptionEqualToValue={(option, selected) =>
        option.sales === selected.sales
      }
      renderInput={(params) => <TextField {...params} />}
      onChange={handleChange}
      value={value ?? null}
      sx={{ cursor: "pointer", pointerEvents: "auto" }}
    />
  );
}
